// Pure formatters used by `EditablePromptCardDryRun` to render the
// result panel. Lives in its own module so:
//   1) react-refresh doesn't complain about a non-component export in
//      the component file (slice D needed `buildResultRows` exported
//      for tests).
//   2) the helpers are unit-testable in isolation.

export function formatValue(value: unknown): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "string") {
    if (value.trim() === "") return "—";
    return value;
  }
  if (Array.isArray(value)) {
    if (value.length === 0) return "—";
    return value.join(", ");
  }
  return String(value);
}

export function isPopulated(value: unknown): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === "string" && value.trim() === "") return false;
  if (Array.isArray(value) && value.length === 0) return false;
  return true;
}

export type DryRunResultRow = { key: string; value: string; populated: boolean };

/**
 * Render a sorted, populated-first pair list for the dry-run result
 * panel. Populated rows lead so the trainer sees the "good" half
 * first; null rows are dimmed so they don't drown the signal.
 */
export function buildResultRows(parsed: Record<string, unknown>): DryRunResultRow[] {
  const entries = Object.entries(parsed).map(([key, value]) => ({
    key,
    value: formatValue(value),
    populated: isPopulated(value),
  }));
  entries.sort((a, b) => {
    if (a.populated === b.populated) return a.key.localeCompare(b.key);
    return a.populated ? -1 : 1;
  });
  return entries;
}
